import { z } from 'zod';

export const TeamMergeFormData = z.object({
  survivor: z.string().nullable().default(null),
});
export type TeamMergeFormDataType = z.infer<typeof TeamMergeFormData>;
